import { Asterisk } from "lucide-react";

const ITEMS = [
  "Circular Economy",
  "Net Zero",
  "Waste to Energy",
  "Green Steel",
  "Energy Storage",
  "Biogas · RNG · CBG",
  "SAF Aviation Fuel",
  "Mine Restoration",
  "Carbon Sequestration",
  "NASA Superfoods",
  "Air & Water Treatment",
  "Green Building",
  "Green Cement & Blocks",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <span key={item} className="flex items-center">
        <span className="font-display font-bold uppercase tracking-tight text-2xl sm:text-4xl text-white/90 px-6">
          {item}
        </span>
        <Asterisk className="text-lime" size={28} />
      </span>
    ))}
  </div>
);

const Marquee = () => (
  <div
    data-testid="editorial-marquee"
    className="relative overflow-hidden border-y border-white/10 bg-carbon py-6 sm:py-8"
    aria-hidden="true"
  >
    <div className="flex w-max animate-marquee">
      <Row />
      <Row />
    </div>
  </div>
);

export default Marquee;
